import { render } from "./ToolsCategory.vue?vue&type=template&id=ef629d2a"
import script from "./ToolsCategory.vue?vue&type=script&lang=js"
export * from "./ToolsCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__